import React from 'react';
import { timeText } from './meetingHelpers';
import '../../styles/meetings.css';

/**
 * Chat lines drawn as a conversation: what you wrote sits on the right in a
 * coloured bubble, what everybody else wrote sits on the left with their name
 * above it, and notices from the meeting itself (somebody is waiting to share
 * their screen) are centred between them.
 *
 * Shared by the chat beside the meeting and the record kept afterwards, so a
 * conversation looks the same while it happens and when it is read back.
 */
const ChatLines = ({ messages, withTime = false }) => messages.map((m) => {
    if (m.kind === 'notice') {
        return <div key={m._id} className="mt-chat-notice">{m.text}</div>;
    }
    return (
        <div key={m._id} data-testid={`chat-line-${m._id}`} className={`mt-chat-line ${m.mine ? 'mine' : ''}`}>
            {!m.mine && (
                <span className="mt-chat-who">{m.senderName}{m.isExternal ? ' (guest)' : ''}</span>
            )}
            <span className="mt-chat-text">{m.text}</span>
            {withTime && <span className="mt-chat-time">{timeText(m.createdAt)}</span>}
        </div>
    );
});

export default ChatLines;
